import { RootState } from 'editor/src/store/index';

// The checks that read an image's measured pixels; the others need no measurement.
const isImagePrintCheckEnabled = ({ hostSettings: { enabledWarnings } }: RootState) =>
  !!(enabledWarnings.SemiTransparentPixels || enabledWarnings.FineDetail || enabledWarnings.Gradient);

export default isImagePrintCheckEnabled;
